import { DynatraceAPI } from './utils/dynatrace/dynatrace';
import { DT_MONITORING_CONTEXT_KEY } from './utils/monitoringContext/monitoringContext';

declare global {
  interface Window {
    skipAlloyAnalyticsLoad?: boolean;
    dynatrace?: DynatraceAPI;

    // used to store monitoring context for dynatrace that don't have a built-in API to set it up
    [DT_MONITORING_CONTEXT_KEY]: Record<
      string,
      string | number | boolean | undefined | null
    >;
  }
}

window.skipAlloyAnalyticsLoad = false;

import('./bootstrap');

export {};
